import { Component } from '@angular/core';

@Component({
    selector: 'npp-unauth-wrapper',
    template: `<router-outlet></router-outlet>`,
    styles: [``],
    standalone: false
})
export class UnAuthWrapperComponent { }
